const initState = {
  publicToken: undefined,
  publicDataUnavailable: false,
};

const getters = {
  publicToken: state => {
    return state.publicToken || false;
  },
  publicDataUnavailable: state => {
    return state.publicDataUnavailable || false;
  },
};

const mutations = {
  publicToken(state, val) {
    state.publicToken = val;
    sessionStorage.setItem('public_token', val);
  },
  publicDataUnavailable(state, val) {
    state.publicDataUnavailable = val;
  },
};

const actions = {
  setPublicToken({ commit }, val) {
    commit('publicToken', val);
  },
  setPublicDataUnavailable({ commit }, val) {
    commit('publicDataUnavailable', val);
  },
};

export default {
  namespaced: true,
  state: () => initState,
  getters,
  mutations,
  actions,
};
